// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  apiUrl: 'https://cms-expo2025.unictive.net/api',
  urlAnalytic: 'https://gecko.kelolain.id/ws',

  lang: 'en',
  eventId: '1',
  google_cliendID:
    '158126023962-75t2l8ko622luj326nvd7g7eg10ui1sp.apps.googleusercontent.com',
  // appVersion: 'v'+require('../../package.json').version ,
  webUrl: 'https://expo.bca.co.id',
  chatClient: 'bca2023',
  prefixRoomDataLivechat: 'expo2025/masterlivechat',
  socketUrlChat: 'https://broadcast.kelolain.id:6002/',
  keyPrefix: 'kelolain/',
  eventOrganizerName: 'BCA Expo',
  eventOrganizerEmail: 'bcaexpo@mailinator.com',
  KSMLivechatCode: '4Lw7nQrY',
  OfflineMapCode: 'kzGOzLWB',
  GeneralExhibitorCode: 'NrPFYKDS',
  KKBMainExhibitorCode: 'bMyxVVmn',
  KPRMainExhibitorCode: 'oitouPuF',
  chatAPI: 'https://broadcast.kelolain.id',
  apiLivechat: 'https://expo-livechat.kelolain.id',
  captchaKey: '6Lc6OUYhAAAAAA0wExYi9toPXpDrufm1M0K584-_',

  urlAnalyticURL: 'https://analytic.kelolain.id/api/make-url',

  // baseUrl: "https://pameran.dmundus.net/v1",

  baseUrlAntrian: 'https://queue-bca-cms.kelolain.id/',
  baseUrlShare: 'https://expo.bca.co.id/',
  socketIoConfig: {
    url: 'https://quiktiv.unictive.com:1234',
    options: {
      // autoConnect:true,
      transports: ['websocket'],
      secure: true,
      reconnection: true,
    },
  },
  KKBUrl: 'https://virtualmall.idofocus.co.id:25443/car-list',
  KKBSimulasiUrl: 'https://virtualmall.idofocus.co.id:25443/car-simulation',
  KKBRefinacing: 'https://virtualmall.idofocus.co.id:25443/refinancing-center',
  KKBEV: 'https://virtualmall.idofocus.co.id:25443/car-list',
  KSMUrl: 'https://simulasi-motor-staging.idofocus.co.id:25443/form',
  KKBUrlPromo: 'https://virtualmall.idofocus.co.id:25443/package-list',
  KKBvirtualMall: 'https://virtualmall.idofocus.co.id:25443/cars',
  API2Url: 'https://pameran.dmundus.net/v1/api',
  API3Url: 'https://beta.unictdev.com/unictive-location/api',
  HallKSMID: '1',
  HallKKBOnline: '2',
  HomeBunga: '30',
  HallKPR: '4',
  HallSolusiID: '3',
  LandingVideoHome: '1',
  LandingVideoCountdown: '2',
  PastEventType: '6',
  HomeBannerType: '3',
  HomeDataType: '5',
  HomeSpesialPromoType: '1',
  HomeSpesialSolusiType: '4',
  HomeOfflineLainnya: '13',
  KPRBannerType: '7',
  KPRBannerPromo: '8',
  KPRBannerPromoMain: '20',
  KPRBannerPilihanRumah: '9',
  KPRBannerLinkSolusi: '17',
  KKBBannerLinkSolusi: '18',
  KSMBannerLinkSolusi: '19',
  KSMBannerType: '11',
  KSMBannerKategoriMotor: '28',
  KKBBannerType: '10',
  KKBBannerTrendKategory: '21',
  SolusiBannerType: '12',
  OfflineBannerType: '14',
  OfflinePromo: '15',
  OfflineShuttle: '16',
  UnitBisnisType: '5',
  provinceDefault: '6',
  roomLive: '5',
  roomOffline: '6',
  roomHomePage: '7',
  surveyOnlineID: '1',
  surveyOfflineID: '18',
  sessionIntipKeseruan: '33',
  defaultChatText:
    'Selamat datang di Live Chat BCA Expoversary 2025.<br>Kami siap melayani setiap: Hari Senin - Minggu Pukul 08.30 - 17.30 WIB<br>Dengan senang hati kami akan memberikan informasi yang Bapak/Ibu butuhkan.',
  defaultChatText2:
    'Selamat datang di Live Chat BCA Expoversary 2025.<br>Kami siap melayani setiap: Hari Senin - Jumat Pukul 08.30 - 17.30 WIB<br>Dengan senang hati kami akan memberikan informasi yang Bapak/Ibu butuhkan.',
  firebase: {
    apiKey: 'AIzaSyBZ9lyzDXJ3B_wcvVjKIOwBKVB6cx5hNiw',
    authDomain: 'dev-ibof-expo.firebaseapp.com',
    databaseURL:
      'https://dev-ibof-expo-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'dev-ibof-expo',
    storageBucket: 'dev-ibof-expo.appspot.com',
    messagingSenderId: '190316441131',
    appId: '1:190316441131:web:0cde95bac30524d18b046e',
    measurementId: 'G-0QY7KPP4NZ',
  },
  zoom: {
    apiKey: '',
    apiSecret: '',
  },
  zoomweb: {
    apiKey: '',
    apiSecret: '',
  },
  dateGuard: '2021-02-24T09:00:00',
  dateGuardOffline: '2021-09-09T00:00:00',
  memberActivity: {
    scanMember: '1',
    scanExhibitor: '2',
    scanExhibitorPic: '3',
    scanExhibitorBrochure: '4',
    scanSession: '5',
    scanActivities: '6',
    answerSurvey: '10',
    answerQuiz: '11',
    unlockBadges: '12',
    transactionTicket: '13',
    transactionShop: '14',
    loginRegister: '15',
    LihatProfileBrand: '16',
    LihatProfileProductCategory: '17',
    LihatProfileProduct: '18',
    LihatProfileKPR: '19',
    LihatVideoBrand: '20',
    LihatVideoProductCategory: '21',
    LihatVideoProduct: '22',
    LihatVideoKPRProject: '23',
    DownloadBrochureBrand: '24',
    DownloadBrochureProductCategory: '25',
    DownloadBrochureProduct: '26',
    DownloadBrochureKPR: '27',
    ApplyProductBrand: '28',
    ApplyProductProductCategory: '29',
    ApplyProductProduct: '30',
    ApplyProductKPR: '31',
    SearchProductKPR: '32',
    LihatProfileKPRDev: '33',
    LihatGalleryBrand: '34',
    LihatGalleryProduct: '35',
    DownloadPricelistKPR: '36',
    Lihat360Brand: '37',
    LihatGalleryKPRProject: '38',
    Lihat360KPRProject: '39',
    LihatSolusiBoothBrand: '40',
    LihatSolusiBoothProductCategory: '41',
    LihatSolusiProduct: '42',
  },
  provinsiAceh: '20',
  urlAjukanKPR:
    'http://webform.bca.co.id/KPR/Screening-eForm-KPR?sourcecode=F76C1317-E140-4E5C-AB6F-DF300751AA78',
  urlSimulasiKPR: 'https://rumahsaya.bca.co.id/id/simulasi',
  urlRumahSaya: 'https://rumahsaya.bca.co.id/',
  surveyID: '15',
  tokenCode: '5HHAFJ3RE6S4UW1D3J51',
  informationOfflineID: [],
  isClosing: 0,
  kprUrlRumahsaya: {
    infoKPR:
      'https://rumahsaya.bca.co.id/id/info-kpr?utm_source=website&utm_medium=bca%20web&utm_campaign=sac_bca-dtb-adm_kpr_offer%20non%20program-bca%20expo%202023_website_aug_cps_bca%20web%7C23080101921&utm_content=expo.bca.co.id-button-info%20kpr&utm_term=unknown',
    simulasi:
      'https://rumahsaya.bca.co.id/id/simulasi?utm_source=website&utm_medium=bca%20web&utm_campaign=sac_bca-dtb-adm_kpr_offer%20non%20program-bca%20expo%202023_website_aug_cps_bca%20web%7C23080101921&utm_content=expo.bca.co.id-button-simulasi%20kpr&utm_term=unknown',
    daftarProperti:
      'https://rumahsaya.bca.co.id/id/Search-Result?utm_source=website&utm_medium=bca%20web&utm_campaign=sac_bca-dtb-adm_kpr_offer%20non%20program-bca%20expo%202023_website_aug_cps_bca%20web%7C23080101921&utm_content=expo.bca.co.id-button-daftar%20properti%20kpr&utm_term=unknown',
    ajukanKPR: 'https://webform.bca.co.id/KPR/login?utm_campaign=expo',
    trackingPengajuanKPR:
      'https://webform.bca.co.id/kpr/tracking-kpr?utm_source=website&utm_medium=bca%20web&utm_campaign=sac_bca-dtb-adm_kpr_offer%20non%20program-bca%20expo%202023_website_aug_cps_bca%20web%7C23080101921&utm_content=expo.bca.co.id-button-tracking%20pengajuan%20kpr&utm_term=unknown',
    lihatSimulasiLainnya:
      'https://rumahsaya.bca.co.id/id/simulasi?utm_source=website&utm_medium=bca%20web&utm_campaign=sac_bca-dtb-adm_kpr_offer%20non%20program-bca%20expo%202023_website_aug_cps_bca%20web%7C23080101921&utm_content=expo.bca.co.id-button-simulasi%20kpr&utm_term=unknown',
    lihatSemuaPropertiterbaru:
      'https://rumahsaya.bca.co.id/search-result?kondisi_rumah=rumah_baru&utm_source=website&utm_medium=bca%20web&utm_campaign=sac_bca-dtb-adm_kpr_offer%20non%20program-bca%20expo%202023_website_aug_cps_bca%20web%7C23080101921&utm_content=expo.bca.co.id-button-daftar%20properti%20kpr&utm_term=unknown',
    konsultasiKPR: 'https://bca.id/bungaspesialkpr',
  },
  excludeSolusi: [332, 333],
  solusiPopup: [36],
  biddingID: '1',
  newsTypeArticle: '1,2',
  galeriTypeArticle: '3,4',
  liveTypeArticle: '5',
  gCalendarLink:
    'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20240229T041500Z%2F20240303T161500Z&details=Waktunya%20datang%20ke%20BCA%20Expo%202024%2C%20lebih%20mudah%20pesan%20taksi%20di%20bca.id%2Fexpotaksi%0A%0AGunakan%20kode%20promo%20BCAEXPOVERSARY24%20di%20BCA%20mobile%20fitur%20Lifestlye%20atau%20aplikasi%20MyBluebird%0Auntuk%20taksi%20tujuan%20ICE%20BSD%2C%20BCA%20Expo%202024.%0A%0AIkuti%20cara%20berikut%3A%0A%0A1.%20Masuk%20ke%20BCA%20mobile%20fitur%20Lifestlye%20dan%20masuk%20ke%20menu%20Taksi%0A2.%20Pilih%20tujuan%20dan%20lokasi%20jemput%2C%20pilih%20layanan%20Bluebird%0A3.%20Masukkan%20kode%20promo%20di%20atas%2C%C2%A0lalu%C2%A0pesan.&location=ICE%20BSD%20City%2C%20Kab.%20Tangerang&text=Perjalanan%20ke%20BCA%20Expo%202024%20di%20ICE%20BSD%20City%2C%20Kab.%C2%A0Tangerang',
  slideshowBunga: '30',
  slideshowFloating: '36',
};
